import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
const headers = new HttpHeaders()
    .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
    .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class PackageService {
  private url = GlobalService.serverURL;

  constructor(private http: HttpClient) { }

  getMarketPackage(data){
    return this.http.post(this.url + 'package/listing',data, { headers });
  }
  getMyPackage(data){
    return this.http.post(this.url + 'package/purchase_list',data, { headers });
  }
  viewPackageDetail(id:string){
    return this.http.get(this.url + 'package/details?package_id='+id, { headers })
  }
  viewCourseAssignEmployeeList(data:any){
    return this.http.get(this.url + 'course_assign_list?package_id=' + data.package_id + '&course_id=' + data.course_id + 
    '&is_editable=' + data.is_editable + '&is_builder=' + data.is_builder, { headers })
  }
  getSellPackage(data){
    return this.http.post(this.url + 'company/sell_package/listing',data, { headers });
  }
  createPackage(data:any){
    return this.http.post(this.url + 'company/sell_package/create', data, { headers })
  }
  editPackage(data:any){
    return this.http.post(this.url + 'company/sell_package/update', data, { headers })
  }
  deletePackage(data:any){
    return this.http.post(this.url + 'company/sell_package/remove_data',data, { headers })
  }
  viewSellPackageDetail(id:string){
    return  this.http.get(this.url + 'company/sell_package/package_details?package_id='+id , { headers })
  }
  // viewing detail of Package in Sell Package List
  viewPackagId(data){
    return  this.http.post(this.url + 'company/sell_package/perticular_package_detail',data , { headers })
  }

  getPackageDetail(data){
    return  this.http.post(this.url + 'package/details',data , { headers })
  }
  getSellPackageDetail(data){
    return  this.http.post(this.url + 'company/sell_package/package_details',data, { headers })
    // return  this.http.get(this.url + 'company/sell_package/package_details?package_id='+id +'&course_id='+course_id , { headers })
  }
  getPackageStatistics(data){
    return this.http.post(this.url + 'company/sell_package/sell_statistics',data, { headers })
  }
  pubUnpubPackage(data){
    return this.http.post(this.url + 'company/sell_package/publish',data, { headers })
  }

  // ============offer packages
  getFeatureList(data){
    return this.http.post(this.url + 'course_new/feature/get_list',data, { headers })
  }
  getFeatureCalc(data){
    return this.http.post(this.url + 'user/feature_calculation/all_calculation',data, { headers })
  }
  getOfferPackageDetail(data){
    return this.http.post(this.url + 'company/offer_plans/get_o_details',data, { headers })
  }
}
